import { Box, Button, Typography } from "@mui/material";
import invoiceSubscriptionIcon from '../../../src/img/invoice-subscription.png';

const contactIntercom = () => {
  Intercom(
    'showNewMessage',
    'Olá! Tenho interesse em contratar o Módulo Financeiro.'
  );
};

const InvoicesSubscriptionContainer = () => {

    return (
        <Box sx={{ backgroundColor: 'background.default', p: '10% 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ p: '0rem 6rem' }}>
                <Box sx={{ display: 'flex', p: '0 6rem' }}>
                    <Typography variant="h4" sx={{ color: 'primary.main' }}>Centralize serviços e financeiro em um só lugar</Typography>
                </Box>
                <Box sx={{ display: 'flex', p: '0 6rem', alignItems: 'center', }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '36rem', gap: '2.5rem' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>
                            <Typography variant="body1">
                                Serviço finalizado e pronto: você já pode emitir a cobrança via boleto,
                                cartão de crédito ou pix. Depois, é só acompanhar o status dos pagamentos e gerar NF (disponível em breve).
                            </Typography>
                            <Typography variant="body1">
                                Sem sair do seu fluxo de trabalho, seus serviços se tornam dinheiro na mão e você controla todo o processo para isso!
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Tudo em um mesmo lugar, com controle fácil que só o Produttivo tem.
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Button
                            onClick={() => contactIntercom()}
                            >Contratar agora</Button>
                            <Button variant="cancelDialog"
                                onClick={() =>
                                    window.open(
                                        'https://help.produttivo.com.br/pt-BR/articles/12304601-modulo-financeiro-servicos-e-cobrancas-sob-controle-no-produttivo',
                                        '_blank'
                                    )
                                }
                            >
                                Saiba mais
                            </Button>
                        </Box>
                    </Box>
                    <Box>
                        <img src={invoiceSubscriptionIcon}
                            alt="Resumo de faturas exibindo subtotal de peças, materiais e serviços em valores monetários, com valor total 
                    consolidado e indicação do status de vencimento."
                            style={{ width: '29rem' }} />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default InvoicesSubscriptionContainer;